export default "__VITE_ASSET__BGxjLvgS__"